export default {
    data() {
        return {
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        };
    },
    computed: {
        $windowWidth() {
            return this.windowWidth;
        },
        $windowHeight() {
            return this.windowHeight;
        },
        $isMobile() {
            return this.windowWidth <= 767.98;
        },
        $isTablet() {
            return this.windowWidth <= 991;
        },
    },

    mounted() {
        window.addEventListener('resize', this.handleWindowResize);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    },

    methods: {
        // Updates window dimensions on resize
        handleWindowResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
    },
};
 
